// extracted by mini-css-extract-plugin
export default {"card":"HomeAiNudge_card__Pur-g","icon":"HomeAiNudge_icon__yRKAz","text":"HomeAiNudge_text__-1Xh1","cta":"HomeAiNudge_cta__jSkKr","close":"HomeAiNudge_close__+JLgm"};